/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTransactionByIdOptions,
  GetTransactionByIdStatus200,
  GetTransactionByIdStatus400,
  GetTransactionByIdStatus404,
  GetTransactionByIdStatus500,
} from '../types/GetTransactionById'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTransactionById } from '../clients/getTransactionById'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTransactionByIdQueryKey = ({ path }: Omit<GetTransactionByIdOptions, 'headers'>) =>
  [{ url: '/v1/transactions/:transaction_id', params: path }] as const

type GetTransactionByIdQueryKey = ReturnType<typeof getTransactionByIdQueryKey>

export function getTransactionByIdQueryOptions(
  { path }: GetTransactionByIdOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTransactionByIdQueryKey({ path })
  return queryOptions<
    GetTransactionByIdStatus200,
    ResponseErrorConfig<
      GetTransactionByIdStatus400 | GetTransactionByIdStatus404 | GetTransactionByIdStatus500
    >,
    GetTransactionByIdStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTransactionById({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get a transaction by ID
 * {@link /v1/transactions/:transaction_id}
 */
export function useGetTransactionById<
  TData = GetTransactionByIdStatus200,
  TQueryData = GetTransactionByIdStatus200,
  TQueryKey extends QueryKey = GetTransactionByIdQueryKey,
>(
  { path }: { path: GetTransactionByIdOptions['path'] | (() => GetTransactionByIdOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTransactionByIdStatus200,
        ResponseErrorConfig<
          GetTransactionByIdStatus400 | GetTransactionByIdStatus404 | GetTransactionByIdStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getTransactionByIdQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTransactionByIdQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetTransactionByIdStatus400 | GetTransactionByIdStatus404 | GetTransactionByIdStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
